import { Col, Row, Select } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { useGetMarketplaces } from '../../../../utils/api/marketplaces/useGetMarketplaces';
import { useGetMpCategories } from '../../../../utils/api/mpCategories/useGetMpCategories';
import { useGetStores } from '../../../../utils/api/stores/useGetStores';

const MappingFilters = ({
  selectedMarketplace,
  setSelectedMarketplace,
  selectedStore,
  setSelectedStore,
  selectedCategory,
  setSelectedCategory,
}) => {
  const { mpCategories, isLoading: isMpCategoriesLoading } = useGetMpCategories(
    {
      marketplace__name: selectedMarketplace,
    }
  );

  const { marketplaces, isLoading: isMarketplacesLoading } = useGetMarketplaces(
    { is_active: true }
  );

  const filteredMarketplaces = useMemo(() => marketplaces);

  const { stores, isLoading: isStoresLoading } = useGetStores({
    marketplace__name: selectedMarketplace,
  });

  const mpCategoryDisabled = useMemo(() => {
    return !selectedMarketplace || isMarketplacesLoading;
  }, [selectedMarketplace, isMarketplacesLoading]);

  const mpCategoryOptions = useMemo(() => {
    if (!mpCategories || mpCategories.length === 0) return [];
    return mpCategories.map((category) => ({
      value: category.id,
      label: `${category.label} - ${category.name}`,
    }));
  }, [mpCategories]);

  const marketplaceOptions = useMemo(() => {
    return filteredMarketplaces?.map((marketplace) => ({
      value: marketplace.name,
      label: marketplace.title,
    }));
  }, [filteredMarketplaces]);

  const storeOptions = useMemo(() => {
    return stores?.map((store) => ({
      value: store.id,
      label: store.name,
    }));
  }, [stores]);

  const filterOption = (input, option) => {
    const labelText =
      typeof option?.label === 'string'
        ? option.label
        : option?.searchLabel || '';
    return labelText.toLowerCase().includes(input.toLowerCase());
  };

  useEffect(() => {
    if (selectedMarketplace) {
      if (!storeOptions?.map((store) => store.value).includes(selectedStore)) {
        setSelectedStore(null);
      }
      if (!mpCategoryOptions?.map((c) => c.value).includes(selectedCategory)) {
        setSelectedCategory(null);
      }
    } else if (selectedStore || selectedCategory) {
      setSelectedStore(null);
      setSelectedCategory(null);
    }
  }, [selectedMarketplace]);

  return (
    <Row gutter={[8, 8]}>
      <Col span={6}>
        <Select
          showSearch
          allowClear
          placeholder="Marketplace"
          options={marketplaceOptions}
          loading={isMarketplacesLoading}
          disabled={isMarketplacesLoading}
          value={selectedMarketplace}
          onChange={setSelectedMarketplace}
          filterOption={filterOption}
          style={{ width: '100%' }}
        />
      </Col>
      <Col span={6}>
        <Select
          showSearch
          allowClear
          loading={isStoresLoading}
          disabled={!selectedMarketplace || isStoresLoading}
          placeholder="Store"
          options={storeOptions}
          value={selectedStore}
          onChange={setSelectedStore}
          filterOption={filterOption}
          style={{ width: '100%' }}
        />
      </Col>
      <Col span={12}>
        <Select
          showSearch
          allowClear
          loading={isMpCategoriesLoading}
          placeholder="Catégorie marketplace"
          disabled={mpCategoryDisabled}
          options={mpCategoryOptions}
          value={selectedCategory}
          onChange={setSelectedCategory}
          filterOption={filterOption}
          style={{ width: '100%' }}
        />
      </Col>
    </Row>
  );
};

export default MappingFilters;
